var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolumeGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9144_20359",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 62,
    height: 62
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 0H0V62H62V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9144_20359)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9144_20359",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 62,
    height: 62
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62 0H0V62H62V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9144_20359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1603 42.2816C27.2333 41.2361 27.3183 40.3244 27.5858 38.3671C27.1603 36.6773 26.674 35.3279 25.3732 33.1518C24.8383 33.4679 24.2913 33.7111 23.7077 33.8569C21.1305 34.5256 18.0427 33.553 15.2344 30.5624C10.007 24.9946 10.5783 16.0593 10.5783 16.0593C10.5783 16.0593 17.7873 15.6581 23.5254 19.7063C27.3669 22.4295 29.0203 26.4291 28.1936 29.5291C27.9991 30.2342 27.6952 30.8785 27.2575 31.462C27.7924 32.386 28.2909 33.3342 28.7164 34.1973C29.9928 29.9424 31.3909 26.6601 32.7281 24.1193C33.4818 22.5389 34.4301 21.0558 35.4756 19.682C36.5575 18.1989 37.4693 17.2628 38.0164 16.7158C41.4446 13.0808 42.5266 13.0808 43.6085 12.1448C43.6571 12.0961 43.6207 12.0718 43.5234 12.0718C42.5144 12.0718 35.0015 14.3452 30.7223 23.9612C28.6434 20.6789 29.3364 16.1687 33.6156 12.1448C38.9038 7.19692 46.818 6.75928 49.4195 6.75928C49.9787 6.75928 50.2948 6.77145 50.2948 6.77145C50.2948 6.77145 50.7567 15.0746 46.0885 21.6514C43.4869 25.335 39.8642 27.2679 36.6669 27.2679C35.8159 27.2679 35.0014 27.1342 34.2355 26.8667C32.0716 32.2765 31.1477 36.4463 30.7465 42.5004C31.3665 42.6342 31.9501 42.8287 32.5215 43.0475C34.2356 43.7161 35.7065 44.7495 36.752 46.0503C37.3234 45.9895 37.8948 45.953 38.4904 45.953C44.7026 45.953 49.7234 50.0742 49.7234 55.1801V55.2652H8.73047V55.1801C8.73047 50.0742 12.8759 45.953 17.9818 45.953C18.5046 45.953 19.0152 46.0016 19.5136 46.0746C20.8752 44.3848 22.9418 43.1205 25.3489 42.5491C25.9446 42.4154 26.5403 42.3303 27.1724 42.2816H27.1603Z",
    fill: "#01625F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeGreen);
export default __webpack_public_path__ + "static/media/volume_green.3b6637dc594969c36359515ffff610c2.svg";
export { ForwardRef as ReactComponent };